export default {
  title: 'Підтвердження дії',
  description: 'Будь ласка, підтвердьте дію <b>{name}</b> введенням коду з додатку Google Auth app.',
  confirmation: 'Введіть код підтвердження',
  confirmation_placeholder: 'XXXXXX',
  btn_submit: 'Підтвердити',
}
